/*jshint camelcase: false*/
/*global define, swfobject, console*/
define('casino/game',['module', 'require', 'jquery', 'all/navigation', 'all/dialog', 'all/player/session', 'casino/casino',
		'casino/love', 'casino/game-resize', 'casino/casino-data', 'all/player/playerinfo', 'casino/activity-feed',
		'casino/providers/Yggdrasil', 'casino/providers/Microgaming', 'casino/providers/Evolution', 'casino/providers/CTXM',
		'casino/providers/netent/NetEntLiveCasino', 'casino/providers/PlayNGo', 'casino/providers/nolimit/NoLimitCity',
		'casino/providers/Quickspin', 'casino/providers/Betsoft', 'casino/providers/WMS', 'casino/providers/Thunderkick',
		'casino/providers/NYX', 'all/slidingContentWrapper', 'casino/providers/CasinoProvider'],
    function (module, require, $, navigation, dialog, session, casino, love, gameResize, casinoData, playerinfo, activity,
			  Yggdrasil, Microgaming, Evolution, CTXM, NetEntLiveCasino, PlayNGo, NoLimitCity, Quickspin,
			  Betsoft, Wms, Thunderkick, Nyx, slidingContentWrapper, CasinoProvider) {
        'use strict';
        var configuration = module.config();
        var EXPRESS_INSTALL = navigation.staticURL('flash/expressInstall.swf');
        var IFRAME = 'iframe';
        var SCRIPT = 'script';
        var freeModeConfigFunctions = {};
        var realModeConfigFunctions = {};
        var game = {};

        function verifyCurrency(gameCurrency) {
            if (gameCurrency && (gameCurrency !== playerinfo.info.currencyCode)) {
                dialog.load('currencyMessage', {currencyCode: gameCurrency});
            }
        }

        function switchToIngame(game, options) {
            var defaults = {};
            options = $.extend(defaults, options);
            showHideMoneyMode(options, session);
            setGameInfo(game);
            var $gameHolder = options.gameHolder;
            $gameHolder.find('.background').hide();
            $gameHolder.find('.background img').hide();
            love.ingame($gameHolder, game);
            var id = 'loaded-game-' + $gameHolder.index();
            var $game = $gameHolder.find('.game');
            $game.empty();
            var width = $game.data('width');
            var height = $game.data('height');

            if (isLocalMock(options)) {
                options.type = IFRAME;
                if (options.flashVars) {
                    options.src = options.src + '?' + $.param(options.flashVars);
                }
            }

            if (options.type === IFRAME) {
                $('<iframe>', {
                    id: id,
                    src: options.src,
                    width: width,
                    height: height,
                    scrolling: 'no'
                }).appendTo($game);
            } else if (options.type === SCRIPT) {
                var $scriptDiv = $('<div>', {
                    id: id,
					width: width,
					height: height
                }).appendTo($game);
                $('<script>', {
                    src: options.src
                }).appendTo($scriptDiv);
			} else if (options.type === 'launch') {
				options.launch.callback(options.launch.options, $game, id);
				gameResize.resize();
            } else {
                $('<div>', {
                    id: id
                }).appendTo($game);
                swfobject.embedSWF(options.src, id, width, height, '10', EXPRESS_INSTALL, options.flashVars, options.flashParams, options.attributes);
            }
            gameResize.scrollIntoView(1000);
        }

        function isLocalMock(options) {
            return options.src !== undefined && options.src[0] === '/';
        }

        function showHideMoneyMode(options, session) {
            var $moneyMode = $('.money-mode');
            if (options.hideMoneySwitch || !session.authenticated) {
                $moneyMode.hide();
                $moneyMode.next('.separator').hide();
            } else {
                $moneyMode.show();
            }
        }

        function switchToRealMode(game, options) {
            casino.mode = 'real';
            switchToIngame(game, options);
        }

        function switchToFreeMode(game, options) {
            casino.mode = 'free';
            switchToIngame(game, options);
        }

        function showVariants($gameHolder, groupKey) {
            var group = casinoData.games[groupKey];
            var $gameGroup = $gameHolder.find('.game-group');
            $gameHolder.find('.love').hide();
            $gameGroup.find('h1').text(group.name);
            $gameGroup.find('p').text(group.shortDescription);
            var $gameBackgroundImage = $gameHolder.find('.background img');
            $gameBackgroundImage.attr('src', navigation.dynamicURL(group.icon));
            $gameBackgroundImage.show();
            var $buttons = $gameGroup.find('.buttons');
            $buttons.empty();
            $buttons.click(function () {
                $gameBackgroundImage.attr('src', '');
            });
            $.each(group.gameOrder, function (index, gameKey) {
                var game = casino.getMatchingGame(gameKey);
                if (!game) {
                    return;
                }

                var link = $('<a href="javascript:">').html(game.shortDescription);

                link.on('click', function () {
                    casino.replaceGameIdInLocationHash(groupKey, gameKey);
                });
                link.appendTo($buttons);
                if (index === 0) {
                    setGameInfo(game);
                }
            });
            $gameGroup.show();
        }

        function showNoFreeMode($gameHolder, game) {
            var $game = $gameHolder.find('.game');
            $gameHolder.find('.love').hide();
            var $inner = $('<div>', {
                'class': 'inner'
            }).appendTo($game);
            $('<h1>').appendTo($inner);
            $('<p>').appendTo($inner);
            $('<div>', {
                'class': 'buttons clearfix'
            }).appendTo($inner);
            $game.find('h1').text(game.name);
            var $gameBackground = $gameHolder.find('.background');
            var $gameBackgroundImage = $gameHolder.find('.background img');
            $gameBackgroundImage.attr('src', navigation.dynamicURL(game.icon));
            $gameBackgroundImage.show();
            $gameBackground.show();
            var $buttons = $game.find('.buttons');
            $buttons.empty();
            $buttons.click(function () {
                $gameBackgroundImage.attr('src', '');
            });
            if (session.authenticated) {
                $game.find('p').text(configuration.youNeedToPlayRealMoneyText);
                var realMoneyLink = $('<a href="javascript:">').html(configuration.toRealMoneyText);
                var ingame = require('casino/ingame');
                realMoneyLink.click(ingame.switchToRealMode);
                realMoneyLink.appendTo($buttons);
            } else {
                $game.find('p').text(configuration.youNeedToBeLoggedInText);
                var loginLink = $('<a href="javascript:">').html(configuration.loginText);
                loginLink.click(slidingContentWrapper.showSlidingLoginPopup);
                loginLink.appendTo($buttons);
                var notAMemberLink = $('<a href="javascript:">').html(configuration.notAMemberText);
                notAMemberLink.click(slidingContentWrapper.showSlidingSignup);
                notAMemberLink.appendTo($buttons);
            }
            $game.show();
            gameResize.scrollIntoView(1000);
        }

        function setGameInfo(game) {
            var $gameNameDescription = $('#casino-ingame').find('#game-name-description');

            $gameNameDescription.find('h1').text(game.name);
            $gameNameDescription.find('p').text(game.description);

            var url = '/pp?flow=GameRule&providerId=' + game.provider + '&gameId=' + game.id;

            var $gameRuleButton = $gameNameDescription.find('a');
            $gameRuleButton.unbind('click');
            $gameRuleButton.click(function () {
                openGameRule(url);
            });

            var $help = $('.help');
            $help.unbind('click');

            $help.click(function () {
                openGameRule(url);
            });

        }

        function openGameRule(url) {
            var height = $(window).height();
            window.open(url, 'GameRules', 'height=' + height + ',width=500,scrollbars=yes,location=yes,menubar=no');
        }


        function setLicenseLogotype($gameHolder, license) {
            $gameHolder.find('.license').attr('class', 'license ui-icon s20-' + license);
        }

        function pushDialog(title, heading, message) {
            var data = {
                title: title,
                heading: heading,
                message: message
            };
            dialog.load('push', data);
        }

        //Used when player is automatically logged out on server but has not been pushed logout.
        //For example, changed ip during session.
        function serverLogout(title, heading, message) {
            var data = {
                title: title,
                heading: heading,
                message: message
            };
            dialog.load('push', data, session.logout, navigation.gotoLastProductPage);
        }

        function loadGame($gameHolder, gameKey) {
            if ($.isNumeric(gameKey)) {
                gameKey = 'game=' + gameKey;
            }
            var options = {
                referrer: location.pathname,
                gameHolder: $gameHolder,
                hideMoneySwitch: false
            };
            var game = casino.getGame(gameKey);
            var provider = casino.getProvider(game);
            var providerId = game.provider;
            setLicenseLogotype($gameHolder, provider.license);

			var gameMode = (session.authenticated && casino.mode !== 'free') ? 'REAL' : 'FUN';

			var $game = options.gameHolder.find('.game');
			var width = $game.data('width');
			var height = $game.data('height');

			if(providerId == 3) {
				var gameProvider = new CasinoProvider();

				gameProvider.getGameData(game.gameId, gameMode, width, height, function (response) {
					if (response.RESULT && response.RESULT == "NOT_OK") {
						pushDialog("", response.ERROR_HEADER, response.ERROR_MESSAGE);
					} else {
						gameProvider.makeEmptyGameDiv($game, 'loaded-game-'+options.gameHolder.index());

						var params = JSON.parse(response.data.JSON).parameters;
						params.targetElement = 'loaded-game-'+options.gameHolder.index();
						params.width = width;
						params.height = height;

						gameProvider.loadNetentGame(params, 'err');
						options.gameHolder.find('.background').hide();
						options.gameHolder.find('.background img').hide();
					}
				});
			} else if (providerId == 12) {
				var gameProvider = new CasinoProvider();

				gameProvider.getGameData(game.gameId, gameMode, width, height, function(response) {
					if(response.RESULT && response.RESULT == 'NOT_OK') {
						pushDialog('', response.ERROR_HEADER, response.ERROR_MESSAGE);
					} else {
						var params = {
							id: 'loaded-game-'+options.gameHolder.index(),
							URL: response.data.URL,
							width: width,
							height: height,
							$game: $game,
							callback: function() {
								gameProvider.messageEventHandler(options);
							}
						};
						gameProvider.loadIframeGame(params);

						options.gameHolder.find('.background').hide();
						options.gameHolder.find('.background img').hide();
					}
				});
			} else {
				if (session.authenticated && casino.mode !== 'free') {
					$.ajax({
						url: '/GameLoader?gameId=' + game.id + '&providerId=' + providerId,
						type: 'POST'
					}).done(function (data) {
						if (data.loggedout === 'true') {
							serverLogout(data.title, data.header, data.message);
						} else if (data.mode === 'free') {
							console.warn(data.info);
							pushDialog(data.title, data.header, data.message);
							freeModeConfigFunctions[provider.code](game, options);
							var ingame = require('casino/ingame');
							ingame.selectFunModeButton();
						} else if (data.errorDialog) {
							dialog.load('error', data.errorDialog, function () {
								$(this).find('a.ui-button').attr('href', data.errorDialog.redirect);
							});
						} else {
							if (data.isBlockedGame) {
								dialog.load('blockedGameMessage');
							}
							realModeConfigFunctions[provider.code](game, options, data);
						}
					}).fail(function () {
						console.error('Failed to access GameLoader.');
					});
				} else {
					freeModeConfigFunctions[provider.code](game, options);
				}
			}
        }

        function showHelpButton() {
            $('.help').show();
        }

        function hideHelpButton() {
            $('.help').hide();
        }

        function init() {
            // TODO move these functions to separate js file and require them into the provider files.
            var gameFunctions = {
                showHelpButton: showHelpButton,
                hideHelpButton: hideHelpButton,
                switchToFreeMode: switchToFreeMode,
                switchToRealMode: switchToRealMode,
                verifyCurrency: verifyCurrency,
                switchToIngame: switchToIngame,
                showNoFreeMode: showNoFreeMode,
                scrollIntoView: gameResize.scrollIntoView,
                showHideMoneyMode: showHideMoneyMode,
                setGameInfo: setGameInfo
            };

            // TODO make a code review of the provide files and detect common behaviors and move them to a separate file
            // TODO Lets call it CasinoProvider.js
            var yggdrasil = new Yggdrasil(casino, gameFunctions);
            freeModeConfigFunctions.YGGDRASIL = function (game, options) {
                yggdrasil.freeMode(game, options);
            };
            realModeConfigFunctions.YGGDRASIL = function (game, options, data) {
                yggdrasil.realMode(game, options, data);
            };

            var microgaming = new Microgaming(casino, gameFunctions);
            freeModeConfigFunctions.MICROGAMING = function (game, options) {
                microgaming.freeMode(game, options);
            };
            realModeConfigFunctions.MICROGAMING = function (game, options, data) {
                microgaming.realMode(game, options, data);
            };

            var evolution = new Evolution(casino, gameFunctions);
            freeModeConfigFunctions.EVOLUTION = function (game, options) {
                evolution.freeMode(game, options);
            };
            realModeConfigFunctions.EVOLUTION = function (game, options, data) {
                evolution.realMode(game, options, data);
            };

            var ctxm = new CTXM(casino, gameFunctions);
            freeModeConfigFunctions.CTXM = function (game, options) {
                ctxm.freeMode(game, options);
            };
            realModeConfigFunctions.CTXM = function (game, options, data) {
                ctxm.realMode(game, options, data);
            };

            var netEntLiveCasino = new NetEntLiveCasino(casino, gameFunctions);
            freeModeConfigFunctions.NETENT_LIVE_CASINO = function (game, options) {
                netEntLiveCasino.freeMode(game, options);
            };
            realModeConfigFunctions.NETENT_LIVE_CASINO = function (game, options, data) {
                netEntLiveCasino.realMode(game, options, data);
            };

            var playNGo = new PlayNGo(casino, gameFunctions);
            freeModeConfigFunctions.PLAY_N_GO = function (game, options) {
                playNGo.freeMode(game, options);
            };
            realModeConfigFunctions.PLAY_N_GO = function (game, options, data) {
                playNGo.realMode(game, options, data);
            };

            var noLimitCity = new NoLimitCity(casino, gameFunctions);
            freeModeConfigFunctions.NOLIMITCITY = function (game, options) {
                noLimitCity.freeMode(game, options);
            };
            realModeConfigFunctions.NOLIMITCITY = function (game, options, data) {
                noLimitCity.realMode(game, options, data);
            };

            var quickspin = new Quickspin(casino, gameFunctions);
            freeModeConfigFunctions.QUICKSPIN = function (game, options) {
                quickspin.freeMode(game, options);
            };
            realModeConfigFunctions.QUICKSPIN = function (game, options, data) {
                quickspin.realMode(game, options, data);
            };

            var betsoft = new Betsoft(casino, gameFunctions);
            freeModeConfigFunctions.BETSOFT = function (game, options) {
                betsoft.freeMode(game, options);
            };
            realModeConfigFunctions.BETSOFT = function (game, options, data) {
                betsoft.realMode(game, options, data);
            };

			var wms = new Wms(casino, gameFunctions);
			freeModeConfigFunctions.WMS = function (game, options) {
				wms.freeMode(game, options);
			};
			realModeConfigFunctions.WMS = function (game, options, data) {
				wms.realMode(game, options, data);
			};

			var thunderkick = new Thunderkick(casino, gameFunctions);
			freeModeConfigFunctions.THUNDERKICK = function (game, options) {
				thunderkick.freeMode(game, options);
			};
			realModeConfigFunctions.THUNDERKICK = function (game, options, data) {
				thunderkick.realMode(game, options, data);
			};

			var nyx = new Nyx(casino, gameFunctions);
			freeModeConfigFunctions.NYX = function (game, options) {
				nyx.freeMode(game, options);
			};
			realModeConfigFunctions.NYX = function (game, options, data) {
				nyx.realMode(game, options, data);
			};

		}

        /**
         * load a game
         *
         * @param {jQuery} $gameHolder
         * @param {Number|String} gameKey as a number or 'game=XX' or 'group=XX'.
         */
        game.load = function ($gameHolder, gameKey) {
            var $game = $gameHolder.find('.game');
            $game.empty();

            if (/^group=/.test(gameKey)) {
                showVariants($gameHolder, gameKey);
            } else {
                loadGame($gameHolder, gameKey);
            }
        };
        game.openGameRule = openGameRule;
        game.init = init;

        $(function () {
            game.init();
        });

        return game;
    });

